import React from 'react'
import { components } from 'react-select'

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 10.39 16.25"
        style={{ width: '10px', height: '100%', marginRight: '10px' }}
      >
        <defs></defs>
        <path style={{ fill: '#5e79fb' }} d="M5.2,16.25,0,11H10.39Z" />
        <path style={{ fill: '#5e79fb' }} d="M5.2,0l5.19,5.25H0Z" />
      </svg>
    </components.DropdownIndicator>
  )
}

export default DropdownIndicator
